export default __webpack_public_path__ + "static/media/bu-castem.2a0ab8fb.png";